/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import { useSelect } from "@wordpress/data";
import {
	Tip,
	PanelBody,
	BaseControl,
	ColorPalette,
	ToggleControl,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";

function Inspector(props) {
	const { attributes, setAttributes } = props;
	const { defaultColors } = useSelect((select) => {
		return {
			defaultColors:
				select("core/block-editor")?.getSettings()?.__experimentalFeatures
					?.color?.palette?.default,
		};
	});
	const openEffectOptions = [
		{
			value: "none",
			label: __("None", "ghub-gallery-lightbox"),
		},
		{
			value: "zoom",
			label: __("Zoom", "ghub-gallery-lightbox"),
		},
		{
			value: "fade",
			label: __("Fade", "ghub-gallery-lightbox"),
		},
	];

	const slideEffectOptions = [
		{
			value: "none",
			label: __("None", "ghub-gallery-lightbox"),
		},
		{
			value: "zoom",
			label: __("Zoom", "ghub-gallery-lightbox"),
		},
		{
			value: "fade",
			label: __("Fade", "ghub-gallery-lightbox"),
		},
		{
			value: "slide",
			label: __("Slide", "ghub-gallery-lightbox"),
		},
	];
	return (
		<InspectorControls>
			<PanelBody
				title={__("Lightbox", "ghub-gallery-lightbox")}
				initialOpen={false}
			>
				<ToggleControl
					label={__("Lightbox", "ghub-gallery-lightbox")}
					help={
						attributes.ghubGalleryLightbox
							? "Lightbox is On"
							: "Lightbox is Off."
					}
					checked={attributes.ghubGalleryLightbox}
					onChange={() =>
						setAttributes({
							ghubGalleryLightbox: !attributes.ghubGalleryLightbox,
						})
					}
				/>
				{attributes.ghubGalleryLightbox && (
					<>
						<Tip>
							{__(
								"This feature will work on frontend.",
								"ghub-gallery-lightbox"
							)}
						</Tip>
						<br />
						<br />
						<ToggleControl
							label={__("Loop", "ghub-gallery-lightbox")}
							checked={attributes.ghubLightboxLoop}
							onChange={() =>
								setAttributes({
									ghubLightboxLoop: !attributes.ghubLightboxLoop,
								})
							}
						/>
						<ToggleControl
							label={__("Keyboard Navigation", "ghub-gallery-lightbox")}
							checked={attributes.ghubLightboxKeyboardNavigation}
							onChange={() =>
								setAttributes({
									ghubLightboxKeyboardNavigation:
										!attributes.ghubLightboxKeyboardNavigation,
								})
							}
						/>
						<ToggleControl
							label={__("Close On Outside Click", "ghub-gallery-lightbox")}
							checked={attributes.ghubLightboxCloseOnOutsideClick}
							onChange={() =>
								setAttributes({
									ghubLightboxCloseOnOutsideClick:
										!attributes.ghubLightboxCloseOnOutsideClick,
								})
							}
						/>
						<ToggleControl
							label={__("Zoomable", "ghub-gallery-lightbox")}
							checked={attributes.ghubLightboxZoomAble}
							onChange={() =>
								setAttributes({
									ghubLightboxZoomAble: !attributes.ghubLightboxZoomAble,
								})
							}
						/>
						<ToggleControl
							label={__("Draggable", "ghub-gallery-lightbox")}
							checked={attributes.ghubLightboxDraggable}
							onChange={() =>
								setAttributes({
									ghubLightboxDraggable: !attributes.ghubLightboxDraggable,
								})
							}
						/>

						<ToggleGroupControl
							__nextHasNoMarginBottom
							label={__("Effect", "ghub-progress-bar")}
							value={attributes.ghubLightboxOpenEffect}
							onChange={(newValue) => {
								setAttributes({ ghubLightboxOpenEffect: newValue });
							}}
						>
							{openEffectOptions.map(({ value, label }) => {
								return (
									<ToggleGroupControlOption
										key={value}
										value={value}
										label={label}
									/>
								);
							})}
						</ToggleGroupControl>
						<ToggleGroupControl
							__nextHasNoMarginBottom
							label={__("Slide Effect in lightbox", "ghub-progress-bar")}
							value={attributes.ghubLightboxSlideEffect}
							onChange={(newValue) => {
								setAttributes({ ghubLightboxSlideEffect: newValue });
							}}
						>
							{slideEffectOptions.map(({ value, label }) => {
								return (
									<ToggleGroupControlOption
										key={value}
										value={value}
										label={label}
									/>
								);
							})}
						</ToggleGroupControl>
						<BaseControl label={__("Overlay Color", "ghub-video-lightbox")}>
							<ColorPalette
								colors={defaultColors}
								enableAlpha
								value={attributes.ghubOverlayColor}
								onChange={(newColor) =>
									setAttributes({ ghubOverlayColor: newColor })
								}
							/>
						</BaseControl>
					</>
				)}
			</PanelBody>
		</InspectorControls>
	);
}

export default Inspector;
